import { Component, OnInit } from '@angular/core';
import { ContactForm } from '../../../models';
import { AuthService, MessagesServices, ScrollService } from '../../api';
import { ToastyService, ToastOptions } from 'ng2-toasty';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
  private model: ContactForm = new ContactForm();
  private errorArray = [];
  private loading: boolean = false;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  constructor(private authService: AuthService, private sm: MessagesServices, private toastyService: ToastyService,private scrollService: ScrollService) {
    this.messages = this.sm.messags;
    this.setMessages();
  }

  ngOnInit() {
    this.scrollService.enableScrollIfDisabled();
  }
  /**
   * getting system messages
   **/

  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_MESSAGE_SENT_SUCCESSFULLY') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
      }
      // alert(this.msg1);
      // alert(this.msg2);
      // alert(this.msg3);
      // alert(this.msg4);
    }
  }
  submitContactUs() {
    // this.setMessages();
    this.authService.postContactForm(this.model).subscribe((res) => {
      this.model = new ContactForm();
      let toastOptions: ToastOptions = {
        title: this.title1,
        msg: this.msg1,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.loading = false;
      this.toastyService.success(toastOptions);
    }, (err) => { this.handleErrors(err); });
  }

  handleErrors(err: any) {
    this.errorArray = [];
    let validationErrors = JSON.parse(err._body);
    if (err._body) {
      for (let index = 0; index < validationErrors.length; index++) {
        this.errorArray[validationErrors[index].field] = validationErrors[index].message;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/cms/support/support.component.ts